import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	dialogTitle: {
		id: 'project-details.avatar-picker-dialog.dialog-title',
		defaultMessage: 'Choose an icon',
		description: '',
	},
	selectAvatar: {
		id: 'project-details.select-avatar-action-text',
		defaultMessage: 'Select',
		description: '',
	},
	defaultListTitle: {
		id: 'project-settings-apps.avatar-modal.default-list-title',
		defaultMessage: 'Default icons',
		description: '',
	},
	moreIconsButtonLabel: {
		id: 'project-settings-apps.avatar-modal.more-icons-button-label',
		defaultMessage: 'Show more icons',
		description: 'Label for the button that shows more icons in the avatar picker dialog',
	},
});
